var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M616 480H256C132.5 480 32 379.516 32 256S132.5 32 256 32S480 132.484 480 256C480 317.875 455.312 375.484 410.469 418.203C407.281 421.25 407.156 426.328 410.219 429.516C413.219 432.703 418.281 432.828 421.531 429.797C469.562 384.016 496 322.297 496 256C496 123.656 388.344 16 256 16S16 123.656 16 256S123.656 496 256 496H616C620.406 496 624 492.422 624 488S620.406 480 616 480ZM152 256C152 313.344 198.656 360 256 360S360 313.344 360 256S313.344 152 256 152S152 198.656 152 256ZM344 256C344 304.531 304.531 344 256 344S168 304.531 168 256S207.469 168 256 168S344 207.469 344 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTape);
export default __webpack_public_path__ + "static/media/tape.54b0c52cde90a4b8d548d6d1d08b69a2.svg";
export { ForwardRef as ReactComponent };